import {Component, Input, OnInit} from '@angular/core';
import {LegendData} from './legend-data';

@Component({
  selector: 'app-dot-legend',
  templateUrl: './dot-legend.component.html',
  styleUrls: ['./dot-legend.component.scss']
})
export class DotLegendComponent implements OnInit {
  @Input() legendData: LegendData;
  constructor() { }

  ngOnInit() {
  }

}
